import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ConnectionState {
  isConnected: boolean;
  reconnectAttempts: number;
  lastConnectedTime: string | null;
  error: string | null;
}

const initialState: ConnectionState = {
  isConnected: false,
  reconnectAttempts: 0,
  lastConnectedTime: null,
  error: null,
};

const connectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setConnected: (state) => {
      state.isConnected = true;
      state.reconnectAttempts = 0;
      state.lastConnectedTime = new Date().toISOString();
      state.error = null;
    },
    setDisconnected: (state) => {
      state.isConnected = false;
    },
    incrementReconnectAttempts: (state) => {
      state.reconnectAttempts += 1;
    },
    resetReconnectAttempts: (state) => {
      state.reconnectAttempts = 0;
    },
    setConnectionError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.isConnected = false;
    },
  },
});

export const {
  setConnected,
  setDisconnected,
  incrementReconnectAttempts,
  resetReconnectAttempts,
  setConnectionError,
} = connectionSlice.actions;

export default connectionSlice.reducer;
